import { buttonBaseClasses as muiButtonBaseClasses } from '@mui/material/ButtonBase';

// eslint-disable-next-line deprecation/deprecation
export { default as ButtonBase, type ButtonBaseProps } from './ButtonBase';
export { touchRippleClasses } from '@mui/material/ButtonBase';
import './buttonBaseModuleAugmentations';

/**
 * @deprecated Unsupported component: This is an internal component, use Button instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const buttonBaseClasses = muiButtonBaseClasses;
